(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-parts-number"] && !Shopify.designMode) return;
  try {
    
    // Запасной путь: записи группы ещё нет — берём товары с тем же тегом 777 через Storefront API (до 50 штук).
    class RelatedPartsNumber extends HTMLElement {
        constructor() {
            super();
            this.endCursor = null;
            this.hasNextPage = false;
            this.loading = false;
            this.productId = this.dataset.id || null;
            this.tag = this.dataset.tag || null;
            this.token = window.storefrontConfig && window.storefrontConfig.token;
            this.storefrontUrl = this.dataset.storefrontUrl;
            this.perPage = parseInt(this.dataset.perPage) || 50;
        }

        connectedCallback() {
            if (!this.tag || !this.token) return this.hideSection();
            const start = () => this.load();
            // после загрузки страницы, чтобы не мешать скорости
            if (document.readyState === 'complete') setTimeout(start, 0);
            else window.addEventListener('load', () => setTimeout(start, 0), { once: true });
            const loadBtn = this.querySelector('.related-parts__load');
            if (loadBtn) loadBtn.addEventListener('click', () => this.load(this.endCursor));
        }

        hideSection() {
            const section = this.closest('.shopify-section');
            if (section) section.style.display = 'none';
        }

        async load(cursor = null) {
            if (this.loading) return;
            this.loading = true;
            this.loaded = true;
            const loader = this.querySelector('.loading-indicator');
            if (loader) loader.style.display = 'block';
            try {
                const response = await fetch(this.storefrontUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': this.token },
                    body: JSON.stringify({
                        query: `query($q: String!, $first: Int!, $after: String) {
                            products(first: $first, after: $after, query: $q) {
                                edges { node { id title handle } }
                                pageInfo { hasNextPage endCursor }
                            }
                        }`,
                        variables: {
                            q: `tag:${this.tag}${this.productId ? ` AND NOT id:${this.productId}` : ''}`,
                            first: this.perPage,
                            after: cursor
                        }
                    })
                });
                const result = await response.json();
                const products = result && result.data && result.data.products;
                if (!products) throw new Error('no data');
                const list = this.querySelector('.related-parts-number__list');
                const html = products.edges.map(e => {
                    const t = e.node.title.trim();
                    const title = t.includes('|') ? t.split('|')[0].trim() : t.split(/\s+/)[0];
                    return `<li class="related-parts-number__list-item"><a href="/products/${e.node.handle}" class="related-parts-number__list-item__link">${title}</a></li>`;
                }).join('');
                list.insertAdjacentHTML('beforeend', html);
                if (!list.children.length) return this.hideSection();
                const details = this.closest('details');
                if (details) details.classList.remove('is-pending');
                this.endCursor = products.pageInfo.endCursor;
                this.hasNextPage = products.pageInfo.hasNextPage;
                const loadBtn = this.querySelector('.related-parts__load');
                if (loadBtn) loadBtn.style.display = this.hasNextPage ? 'block' : 'none';
            } catch (error) {
                console.error('Related parts:', error);
            } finally {
                this.loading = false;
                if (loader) loader.style.display = 'none';
            }
        }
    }

    if (customElements.get('related-parts-number') === undefined) {
        customElements.define('related-parts-number', RelatedPartsNumber);
    }

  } catch(e) { console.error(e); }
})();
})();
